import { useGetBrokersRequiredPaymentsMetadata } from 'utils/web_api'

import { RequiredPaymentsProvider } from './RequiredPaymentsContext'
import RequiredPaymentsViewContent from './RequiredPaymentsViewContent'

const RequiredPaymentsView = () => {
  // Fetch metadata for automated carriers and autopay states
  const { data: metadata, isLoading: isLoadingMetadata } = useGetBrokersRequiredPaymentsMetadata()

  if (isLoadingMetadata) {
    return (
      <div className='max-w-[2400px] mx-auto px-4 pb-6'>
        <div className='flex-col w-full h-full p-4 space-y-4 bg-white rounded-lg max-w-[2400px] mx-auto'>
          <div className='text-gray-500'>Loading...</div>
        </div>
      </div>
    )
  }

  if (!metadata) {
    return (
      <div className='max-w-[2400px] mx-auto px-4 pb-6'>
        <div className='flex-col w-full h-full p-4 space-y-4 bg-white rounded-lg max-w-[2400px] mx-auto'>
          <div className='text-red-500'>Failed to load metadata</div>
        </div>
      </div>
    )
  }

  return (
    <RequiredPaymentsProvider
      automatedCarriers={metadata.automated_payment_carriers}
      autopayStates={metadata.filterable_autopay_states}
    >
      <RequiredPaymentsViewContent />
    </RequiredPaymentsProvider>
  )
}

export default RequiredPaymentsView
